import resolveBannerMedia from './verified-banner-media'

export const getHomefeedSuperDeals = (homefeed) => {
  const superDeals = homefeed?.data?.find(
    (data) => data?.attributes?.style === 'special-awareness',
  )
  const superDealsProductIds = homefeed?.included
    ?.find(
      (data) =>
        data?.type === 'feed-items' &&
        data?.id === superDeals?.relationships?.['feed-items']?.data?.[0]?.id,
    )
    ?.relationships?.products?.data?.map((data) => data?.id)

  const superDealsProducts = (superDealsProductIds || [])
    .map((id) =>
      homefeed?.included?.find(
        (data) => data?.type === 'products' && data?.id === id,
      ),
    )
    .filter((product) => product?.attributes)

  return { superDeals, superDealsProducts }
}

export const getHomefeedBubbleNavigations = (homefeed) => {
  const navigations = homefeed?.data?.find(
    (data) => data?.attributes?.style === 'categories',
  )
  const navigationIds = navigations?.relationships?.['feed-items']?.data?.map(
    (data) => data.id,
  )
  const allNavigations = navigationIds?.map((id) => {
    const navigation = homefeed?.included?.find((data) => data?.id === id)
    return navigation
  })
  const topNavigations = allNavigations?.filter(
    (navigation) => navigation?.attributes?.navigation_type === 'top',
  )
  const bottomNavigations = allNavigations?.filter(
    (navigation) => navigation?.attributes?.navigation_type === 'bottom',
  )

  return { topNavigations, bottomNavigations }
}

export const getHomefeedBanners = (homefeed, isPhone) => {
  const bannersInfo = homefeed?.data?.find(
    (data) => data?.attributes?.style === 'banner',
  )
  const bannerIds = bannersInfo?.relationships?.['feed-items']?.data?.map(
    (data) => data?.id,
  )

  const banners = bannerIds?.map((id) => {
    const banner = homefeed?.included?.find((data) => data?.id === id)
    return {
      ...banner,
      attributes: {
        ...banner?.attributes,
        media: resolveBannerMedia(banner, isPhone),
      },
      auto_slide_ms: bannersInfo?.attributes?.auto_slide_ms ?? '7000',
      show_gradient: bannersInfo?.attributes?.show_gradient ?? false,
    }
  })

  return banners
}
